import { Component } from 'react';

class RestaurantUtils extends Component {

	static getStatusColor(status) {
		switch (status) {
			case 'OPEN':
				return '#759F2E';
			case 'CLOSED':
				return '#000';
			default:
				return '#000';
		}
	}

	static getPosStatusColor(posStatus) {
        switch (posStatus) {
			case 'ONLINE':
				return '#759F2E';
			case 'OFFLINE':
				return '#BF1E2E';
			case 'PAUSED':
				return '#FF990A';
			default:
				return '#000';
		}
	}

	static getOrderStatusColor(orderStatus) {
        switch (orderStatus) {
			case 'ACCEPTED':
				return '#759F2E';
			case 'REFUNDED':
				return '#759F2E';
			case 'CANCELED':
				return '#BF1E2E';
			case 'REJECTED':
				return '#BF1E2E';
			case 'PARTIALLY_REFUNDED':
				return '#FF990A';
			default:
				return '#000';
		}
	}
}

export default RestaurantUtils;



// WEBPACK FOOTER //
// ./src/utils/RestaurantUtils.js